import albumReducer from './';

export default albumReducer;
